import React from "react";
import Label from "./Label";
import ErrorMessage from "./ErrorMessage";
import Input from "./Input";
/**
 * MultiRadio Component
 *
 * This component renders a group of radio buttons with a label. It supports custom labels,
 * container classes, error messages, and dynamic radio button options.
 *
 * @param {string} keyName - The name attribute for the radio buttons.
 * @param {Array} options - The array of options for the radio buttons. Each option should be an object with 'id' and 'name' properties.
 * @param {string} selectedValue - The value of the currently selected radio button.
 * @param {function} onChange - The function to call when a radio button is changed.
 * @param {string} [label] - Optional label for the radio group.
 * @param {string} [labelClassName] - Optional class name for the label.
 * @param {string} [containerClassName] - Optional class name for the container.
 * @param {string} [error] - Optional error message to display.
 * @param {string} [errorMessageClassName] - Optional class name for the error message.
 * @param {string} [labelPosition="top"] - Optional position for the label (e.g., "top", "left").
 *
 * @example
 * const filterOptions = [
 *   { id: '1', name: 'Option 1' },
 *   { id: '2', name: 'Option 2' },
 *   { id: '3', name: 'Option 3' },
 * ];
 *
 * <MultiRadio
 *   keyName="example"
 *   options={filterOptions}
 *   selectedValue="2"
 *   onChange={(e) => console.log(e.target.value)}
 *   label="Select an Option"
 *   labelClassName="custom-label"
 *   containerClassName="custom-container"
 * />
 */

const MultiRadio = ({
  keyName = "",
  options = [],
  selectedValue = "",
  onChange = () => {},
  label = "",
  labelClassName = "",
  containerClassName = "",
  error = "",
  errorMessageClassName = "",
  labelPosition = "top"
}) => {
  const containerClasses = `form_element_wrapper_text ${labelPosition} ${containerClassName}`.trim();

  return (
    <div className={containerClasses}>
      {label && <Label className={labelClassName}>{label}</Label>}
      <div className="multi_radio_group">
        {options.map((option) => (
          <Input
            key={option.id}
            label={option.name}
            type="radio"
            name={keyName}
            value={option.id}
            checked={selectedValue === option.id}
            onChange={onChange}
            inputClassName="builder_radio"
          />
        ))}
      </div>
      {error && <ErrorMessage className={errorMessageClassName}>{error}</ErrorMessage>}
    </div>
  );
};

export default MultiRadio;
